/** * 模块名称: SoftwareSolutions.vue - 软件解决方案 * 模块说明: * 创建时间:
2022-02-15 11:36 * 模块负责人: lkc * 修改记录: */
<template>
  <div>
    <!-- 头部 -->
    <div class="headBanner">
      <div class="headClass">
        <div class="tit">
          <h1>一站式专业服务，为您量身定制</h1>
          <h3>PC端 / 移动端 / 微信端 / H5 / 小程序</h3>
          <h3>
            来自于巨头科技企业的专业技术团队，为您提供全天候的专属服务支持
          </h3>
        </div>
      </div>
    </div>
    <!-- 服务范围 -->
    <div class="contBox">
      <h1>服务范围</h1>
      <ul class="xkPlatform_box">
        <li>
          <img src="@/assets/jj_1.png" />
          <h2>网站建设</h2>
          <!-- 蒙层 -->
          <div class="msk1">
            <img src="@/assets/jj1.png" />
            <h2>网站建设</h2>
          </div>
        </li>
        <li>
          <img src="@/assets/jj_2.png" />
          <h2>小程序</h2>
          <!-- 蒙层 -->
          <div class="msk1">
            <img src="@/assets/jj2.png" />
            <h2>小程序</h2>
          </div>
        </li>
        <li>
          <img src="@/assets/jj_3.png" />
          <h2>商城</h2>
          <!-- 蒙层 -->
          <div class="msk1">
            <img src="@/assets/jj3.png" />
            <h2>商城</h2>
          </div>
        </li>
        <li>
          <img src="@/assets/jj_4.png" />
          <h2>H5</h2>
          <!-- 蒙层 -->
          <div class="msk1">
            <img src="@/assets/jj4.png" />
            <h2>H5</h2>
          </div>
        </li>
      </ul>
      <!-- 匠心服务 -->
      <h1>匠心服务</h1>
      <ul class="serviceBox">
        <li class="TitLi">
          <span>1v1需求分析</span>
          <p>
            专业客户经理1对1服务沟通，根据您的行业、竞品、受众等进行细致的剖析，为您量身定制多套解决方案
          </p>
        </li>
        <li class="jtIcons">
          <div class="jtIcon">
            <span></span>
            <span class="jtIcon1"></span>
          </div>
        </li>
        <li class="TitLi">
          <span style="background: #39c0ba">产品深度策划</span>
          <p>
            资深产品经理深度优化方案，从行业市场分析到用户体验设计，结合品牌的自身特性，全方面提升品牌竞争力
          </p>
        </li>
        <li class="jtIcons">
          <div class="jtIcon">
            <span style="background: #3cc08d"></span>
            <span class="jtIcon2"></span>
          </div>
        </li>
        <li class="TitLi">
          <span style="background: #37b259">品牌化视觉传达</span>
          <p>
            资深UI设计师提供设计服务，规范UI色调、ICON、版式，创意Banner设计、交互动效等，提升品牌形象
          </p>
        </li>
        <li class="jtIcons">
          <div class="jtIcon">
            <span style="background: #6fb141"></span>
            <span class="jtIcon3"></span>
          </div>
        </li>
        <li class="TitLi">
          <span style="background: #69a93b">前沿技术研发</span>
          <p>
            来自互联网大厂的工程师团队，经验丰富，技术过硬，更规范的代码编写、更安全的系统架构、更丝滑的用户体验
          </p>
        </li>
      </ul>
      <!-- 为什么选择我们 -->
      <h1 class="aboutTit">为什么选择我们</h1>
      <ul class="about">
        <li>更懂产品设计</li>
        <li>更懂研发技术</li>
        <li>更懂线上营销</li>
        <li>更懂客户需求</li>
      </ul>

      <!-- 客户案例 -->
      <h1>客户案例</h1>
      <h4>展示部分</h4>
      <div class="alImgList">
        <img src="@/assets/al1.png" alt="" />
        <img src="@/assets/al2.png" alt="" />
        <img src="@/assets/al3.png" alt="" />
        <img src="@/assets/al4.png" alt="" />
        <img src="@/assets/al5.png" alt="" />
        <img src="@/assets/al6.png" alt="" />
        <img src="@/assets/al7.png" alt="" />
        <img src="@/assets/al8.png" alt="" />
      </div>
    </div>
    <!-- 尾部 -->
    <div class="footTit">
      <div class="footBox">
        <h1>阿里云、中国移动、中国电信、百度、腾讯、中国—东盟信息港等</h1>
        <h1>核心生态合作伙伴</h1>
        <h3>强支撑 | 大平台 | 高技术 | 优服务</h3>
        <h3>我们拥有100+中大型客户案例，成熟的团队阵容，优质的售后服务</h3>
        <h3>选择我们，您的产品可以远超预期！</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.headBanner {
  background: url('../assets/jiejueBanner.png');
  background-size: 100% 100%;
  height: 360px;
  .headClass {
    width: 1200px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tit {
      width: 70%;
      color: #fff;
      text-align: left;
    }
  }
}
.contBox {
  padding: 30px;
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  .xkPlatform_box {
    box-sizing: border-box;
    list-style: none;
    width: 1200px;
    height: 400px;
    border-radius: 10px;
    background-color: #f2f2f2;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0;
    li {
      list-style: none;
      position: relative;
      width: 240px;
      height: 280px;
      background-color: #fff;
      border-radius: 10px;
      color: #000;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 120px;
      }
      .msk1 {
        width: 240px;
        height: 280px;
        background-color: #02a7f0;
        border-radius: 10px;
        position: absolute;
        top: 0;
        opacity: 0;
        display: flex;
        color: #fff;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 8px;
        box-sizing: border-box;
        img {
          width: 120px;
        }
      }
    }
    li:hover .msk1 {
      opacity: 1;
    }
  }
  .serviceBox {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0;
    .TitLi {
      span {
        width: 160px;
        height: 50px;
        background-color: #3668c2;
        display: block;
        border-radius: 10px;
        color: #fff;
        text-align: center;
        line-height: 50px;
      }
      p {
        width: 160px;
        text-align: left;
      }
    }
    .jtIcons {
      .jtIcon {
        position: relative;
        width: 81px;
        span:first-child {
          display: block;
          width: 30px;
          height: 20px;
          background-color: #3668c2;
        }
        .jtIcon2 {
          border-left: 25px solid #3cc08d !important;
        }
        .jtIcon3 {
          border-left: 25px solid #6fb141 !important;
        }
        span:last-child {
          width: 1px;
          height: 1px;
          background-color: #3668c2;
          display: block;
          border-top: 25px solid #f2f2f2;
          border-right: 25px solid #f2f2f2;
          border-left: 25px solid #3668c2;
          border-bottom: 25px solid #f2f2f2;
          position: absolute;
          right: 0;
          top: -17px;
        }
      }
    }
  }
  .aboutTit {
    margin: 40px auto;
  }
  .about {
    list-style: none;
    display: flex;
    justify-content: space-around;
    li {
      width: 20%;
      height: 100px;
      border-radius: 10px;
      font-size: 18px;
      text-align: center;
      line-height: 100px;
      font-weight: 600;
    }
    li:first-child {
      color: #fff;
      background-color: #845ec2;
    }
    li:nth-child(2) {
      color: #fff;
      background-color: #009efa;
    }
    li:nth-child(3) {
      color: #fff;
      background-color: #00d2fc;
    }
    li:last-child {
      background-color: #38ac98;
      color: #fff;
    }
  }

  .alImgList {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    img {
      width: 30%;
      height: 180px;
      margin: 10px 20px 10px 20px;
    }
  }
}
.footTit {
  width: 100%;
  background-color: #fff;
  .footBox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
  }
}
</style>
